// import React from 'react'
import { useSelector } from "react-redux";

const useLanguageSelector = (englishWord, hindiWord) => {
  const selectedLanguage = useSelector(
    (state) => state.laguagefoetheemployees.COuntsForLanguage
  );

  return selectedLanguage === 1 ? englishWord : hindiWord;
};

export default useLanguageSelector;
